import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WalletService } from '@service/wallet.service';
import { AlertService } from '@service/alert.service';
import { AuthService } from '@service/auth.service';

@Component({
  selector: 'app-referral-reward',
  templateUrl: './referral-reward.component.html',
  styles: [
  ]
})
export class ReferralRewardComponent implements OnInit {

  isLoggedIn: boolean = false
  gotCoupon: boolean = false
  vpa = new FormControl('', Validators.compose([
    Validators.required,
    Validators.pattern(new RegExp('[a-zA-Z0-9\.\-]{2,256}\@[a-zA-Z][a-zA-Z]{2,64}'))
  ]));
  name = new FormControl('', Validators.required);
  currentUser: any;
  totalReward: number = 0;
  claimedRewards: string[] = []
  currentReward: any;

  constructor(
    private dialogRef: MatDialogRef<ReferralRewardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {availableRewards:any[],page:string,currentRewards:any[]},
    private router : Router,
    private authService: AuthService,
    private benefitsService: WalletService,
    private alertService: AlertService
  ) { 
  }

  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe((res)=>{
      this.isLoggedIn = res
    })
    this.data.availableRewards.forEach((x)=>  this.totalReward = x.amount + this.totalReward)
    if(this.isLoggedIn){
      this.authService.userProfile.subscribe((res)=>{
        this.currentUser = res || {};
        if (this.currentUser?.name) {
          this.name.patchValue(this.currentUser.name)
        }
        if (this.currentUser.razorpay?.fundAccountVPA) {
          this.vpa.patchValue(this.currentUser.razorpay.fundAccountVPA)
        }
      })
      this.checkIfMultipleRewards()
    }
  }

  closeDialog(){
    this.dialogRef.close()
  }
  
  goTo(page){
    this.closeDialog()
    if(page === 'rewards'){
      this.router.navigate(['/my-rewards'])
    }else if(page === 'next'){
      if(this.data.availableRewards.findIndex((x)=> x.activity === 'risk_profile_update_rfd') > -1){
        this.router.navigate(['/profile-completion'])
      } else {
        this.router.navigate(['/investment/investpack'])
      } 
    }
  }

  upiDetail() {
    const data = {
      name: this.name.value.replace(/\s+/g, ' ').trim(),
      vpa: this.vpa.value.trim()
    }
    this.benefitsService.rewardToBank(data).subscribe(
      (res) => {
        this.authService.UpdateUserData(false);
        this.currentUser.isEditVpa = false;
      },
      (err: any) => {
        this.currentUser.isEditVpa = false;
      }
    )
  }

  transferPayout(id) {
    let data = {
      rewardId : id
    }
    this.benefitsService.transferPayout(data).subscribe(
      (res) => {
        this.alertService.success(res.message);
      }
    )
  }

  claimReward(id){
    this.closeDialog()
    this.upiDetail()
    this.transferPayout(id)
  }

  checkIfMultipleRewards(){
    let rewardCheck = {
      riskProfile: this.currentUser.rewardBenefits.isRiskProfilingRfd,
      freeSubscription: this.currentUser.rewardBenefits.isFreePackSubscriptionRfd,
      paidSubscription: this.currentUser.rewardBenefits.isPaidPackSubscriptionRfd,
      firstInvestment: this.currentUser.rewardBenefits.isFirstTimeInvestmentRfd
    }

    if(rewardCheck.riskProfile || rewardCheck.freeSubscription || rewardCheck.paidSubscription || rewardCheck.firstInvestment){
      this.claimedRewards = this.data.currentRewards.map(x => x.rewardConfiguration.activity);
      let isPending: boolean = false;
      if(rewardCheck.riskProfile && this.claimedRewards.indexOf('risk_profile_update_rfd') === -1){
        isPending = true
      }

      if(rewardCheck.freeSubscription && this.claimedRewards.indexOf('first_time_investment_rfd') === -1){
        isPending = true
      }

      if(rewardCheck.paidSubscription && this.claimedRewards.indexOf('paid_pack_subscription_rfd') === -1){
        isPending = true
      }

      if(rewardCheck.firstInvestment && this.claimedRewards.indexOf('free_pack_subscription_rfd') === -1){
        isPending = true
      }
      
      if(this.data.page === 'product'){
        this.currentReward = this.data.currentRewards.find((x)=> x.rewardConfiguration.activity === "referral_credits_rfd" && x.status === "PENDING") 
      }

      if(this.data.page === 'riskprofile'){
        this.currentReward = this.data.currentRewards.find((x)=> x.rewardConfiguration.activity === "risk_profile_update_rfd" && x.status === "PENDING")
      }

      if(this.data.page === 'firstTimeInvest'){
        this.currentReward = this.data.currentRewards.find((x)=> x.rewardConfiguration.activity === "first_time_investment_rfd" && x.status === "PENDING")
      }

      if(isPending){
        this.checkPendingRewards()
      }
    } else {
      if(this.data.page === 'product'){
        this.currentReward = this.data.currentRewards.find((x)=> x.rewardConfiguration.activity === "referral_credits_rfd" && x.status === "PENDING") 
      }

      if(this.data.page === 'riskprofile'){
        this.currentReward = this.data.currentRewards.find((x)=> x.rewardConfiguration.activity === "risk_profile_update_rfd" && x.status === "PENDING")
      }

      if(this.data.page === 'firstTimeInvest'){
        this.currentReward = this.data.currentRewards.find((x)=> x.rewardConfiguration.activity === "first_time_investment_rfd" && x.status === "PENDING")
      }
    }
  }

  checkPendingRewards(){
    let rewardCheck = {
      riskProfile: this.currentUser.rewardBenefits.isRiskProfilingRfd,
      freeSubscription: this.currentUser.rewardBenefits.isFreePackSubscriptionRfd,
      paidSubscription: this.currentUser.rewardBenefits.isPaidPackSubscriptionRfd,
      firstInvestment: this.currentUser.rewardBenefits.isFirstTimeInvestmentRfd
    }
    this.authService.checkReward().subscribe((rewards)=>{
      rewards.refered.forEach(x => {
        if(rewardCheck.riskProfile && x.activity === 'risk_profile_update_rfd' && this.claimedRewards.indexOf(x.activity) === -1){
          this.data.availableRewards.push(x)
        }
        if(rewardCheck.firstInvestment && x.activity === 'first_time_investment_rfd' && this.claimedRewards.indexOf(x.activity) === -1){
          this.data.availableRewards.push(x)
        }
        if(rewardCheck.paidSubscription && x.activity === 'paid_pack_subscription_rfd' && this.claimedRewards.indexOf(x.activity) === -1){
          this.data.availableRewards.push(x)
        }
        if(rewardCheck.freeSubscription && x.activity === 'free_pack_subscription_rfd' && this.claimedRewards.indexOf(x.activity) === -1){
          this.data.availableRewards.push(x)
        }
      });
      if(this.data.availableRewards.length){
        this.totalReward = this.data.availableRewards.reduce((x, b)=> x + b.amount, 0)
      }
    })
  }

}
